import React, { useState } from 'react';
import { Line, LineHead } from 'common/components/resourceUpload/FilterForm';
import { DISABLED_DOWNLOAD } from '@/common/constant/filters';
import CatalogUnits from '@/common/components/catalog-units';

export default props => {
  if (props.usage !== 'teaching_resource') return null;

  const [formData, setFormData] = useState(props.value);

  const handleChange = (inField, inEvent) => {
    formData[inField] = inEvent.target.value;
    setFormData(formData);
    props.onChange(formData);
  };

  return (
    <React.Fragment>
      <Line visible={props.usage === 'teaching_resource'}>
        <LineHead required>支持下载</LineHead>
        <View dflex align="center" mt={5}>
          <nx.$rc.radioGroup
            value={nx.get(formData, 'disableDownload')}
            items={DISABLED_DOWNLOAD}
            onChange={handleChange.bind(null, 'disableDownload')}
          />
        </View>
      </Line>

      <Line visible={props.usage === 'teaching_resource'}>
        <LineHead>归属单元</LineHead>
        <CatalogUnits
          className="w100"
          value={formData.courseCatalogueUuid}
          onChange={handleChange.bind(null, 'courseCatalogueUuid')}
        />
      </Line>
    </React.Fragment>
  );
};
